<div class="ws-page">
  <header class="page-head">
    <div>
      <p class="kicker">Audit · System activity</p>
      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Audit trail</h2>
        <app-page-refresh-btn (refresh)="reload()" />
      </div>
      <p class="muted ws-lead">Record of system events for the signed-in authority — who changed what and when.</p>
    </div>
  </header>

  <section class="page-card">
    <div class="form-grid filters">
      <label>
        Entity type
        <select [(ngModel)]="entityType" (ngModelChange)="onFilterChange()">
          <option value="">All</option>
          <option value="sanctioned_plan">Sanctioned plan</option>
          <option value="building_measurement">Building measurement</option>
          <option value="violation_flag">Violation flag</option>
          <option value="scan_job">Scan job</option>
          <option value="scan_processing_run">Processing run</option>
          <option value="bye_law_norm">Bye-law norm</option>
          <option value="pilot_area">Pilot area</option>
        </select>
      </label>
      <label>
        Rows per page
        <select [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </label>
    </div>

    <p class="error" *ngIf="error()">{{ error() }}</p>
    <p class="ws-loading" *ngIf="loading()">Loading audit events…</p>

    <p class="ws-empty" *ngIf="!loading() && !rows().length">No audit events recorded.</p>
    <div class="table-wrap" *ngIf="!loading() && rows().length">
      <table class="data">
        <thead>
          <tr>
            <th class="col-num">#</th>
            <th>When</th>
            <th>Event</th>
            <th>Entity</th>
            <th>Actor</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rows(); let i = index">
            <td class="col-num">{{ rowNumber(i) }}</td>
            <td>{{ $any(r['occurredAt']) | date: 'medium' }}</td>
            <td><strong>{{ r['eventType'] }}</strong></td>
            <td>{{ r['entityType'] }} <span class="num">#{{ r['entityId'] }}</span></td>
            <td>{{ r['actor'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pager" *ngIf="!loading() && total() > 0">
      <span class="pager-meta">{{ rangeLabel() }} · Page {{ page() }} / {{ totalPages() }}</span>
      <div class="actions">
        <button type="button" class="btn secondary" [disabled]="page() <= 1" (click)="goFirst()">First</button>
        <button type="button" class="btn secondary" [disabled]="page() <= 1" (click)="goPrev()">Previous</button>
        <button type="button" class="btn secondary" [disabled]="page() >= totalPages()" (click)="goNext()">Next</button>
        <button type="button" class="btn secondary" [disabled]="page() >= totalPages()" (click)="goLast()">Last</button>
      </div>
    </div>
  </section>
</div>
